module.exports = __webpack_public_path__ + "img/gateway-icon.6ab8031d.svg";